import script from "./annoying-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./annoying-banner.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./annoying-banner.vue?vue&type=style&index=0&id=60dc926f&module=true&lang=less"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./annoying-banner.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__